import { getField } from 'vuex-map-fields'
import enumTipoAplicacao from '@mobilesaude/frontend_libs/enums/enumTipoAplicacao'

// Initial state
const initialState = () => ({
  aplicacoes: [],
  aplicacaoSelecionada: null
})

const state = initialState

const getters = {
  getField,
  selecionada: state => state.aplicacoes.find((app) => app.id_cliente_app === state.aplicacaoSelecionada),
  applicationMenu: (state) => {
    const menuStructure = [
      {
        'name': 'Minhas Aplicações',
        'title': 'Minhas Aplicações',
        'routerName': 'Home',
        'idMenu': 1,
        'icon': 'widgets',
        'iconFill': true,
        'externalLink': false,
        'showChilds': true,
        'showNavCardDash': true,
        'childs': []
      }
    ]

    menuStructure[0].childs = state.aplicacoes.map((app) => {
      let routerPath = `/plataforma/${app.id_cliente_app}`
      let name = app.descricao
      let nameApplication = app.descricao_app

      if (app.tipo_aplicacao === enumTipoAplicacao.tipoPlataformas.atendimento) {
        routerPath = routerPath.concat('/ConfiguradorAplicacao')
        name = app.descricao_app
        nameApplication = ''
      }

      return {
        'name': name,
        'isApplication': true,
        'nameApplication': nameApplication,
        'image': app.icon,
        'idMenu': app.id_cliente_app,
        'idConfigClienteApp': app.id_cliente_app,
        'iconFill': true,
        'routerPath': routerPath,
        'externalLink': false,
        'showNavCardDash': true,
        'description': enumTipoAplicacao.getTipoPlataformaDescription(app.tipo_aplicacao)
      }
    })
    // TODO: 19/05/2025 martinazzi Desativando até segunda ordem
    /* menuStructure[0].childs.push({
      'name': 'Configurações globais',
      'isApplication': true,
      'nameApplication': '',
      'icon': 'settings',
      'idMenu': 0,
      'idConfigClienteApp': 0,
      'iconFill': true,
      'routerPath': '/plataforma/0',
      'externalLink': false,
      'showNavCardDash': true,
      'description': 'Configurações globais das plataformas.'
    }) */
    return menuStructure
  }
}

const actions = {}

const mutations = {
  SET_APLICACOES (state, payload) {
    state.aplicacoes = payload.map((app) => {
      return {
        ...app,
        tipo_aplicacao: app.tipo_aplicacao || 1
      }
    })
  },
  SELECIONA_APLICACAO (state, payload) {
    state.aplicacaoSelecionada = payload
  },
  CLEAN (state) {
    const initial = initialState()
    Object.keys(initial).forEach(key => {
      state[key] = initial[key]
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
